import PropTypes from 'prop-types';
import { StyledContainer, StyledIframe } from './ExperienceIframe.styles';

function ExperienceIframe({ data }) {
  return (
    <StyledContainer>
      <StyledIframe
        name={data.name || 'name'}
        allow={data.allow || 'fullscreen'}
        src={data.src || ''}
        title={data.title || 'Title'}
      />
    </StyledContainer>
  );
}

ExperienceIframe.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    allow: PropTypes.string,
    src: PropTypes.string,
    title: PropTypes.string,
  }),
};

ExperienceIframe.defaultProps = {
  data: {
    name: 'speakeasy',
    allow: 'fullscreen; microphone;',
    src: '',
    title: 'Title',
  },
};

export default ExperienceIframe;
